import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { API } from './api';

const DEFAULTS = {
  whatsapp_number: '+919810000000',
  contact_email: 'hello@safehouse.com',
  contact_phone: '+919810000000',
  hero_slides: [],
};

const SettingsContext = createContext(DEFAULTS);

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(DEFAULTS);

  const load = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/settings`);
      setSettings({ ...DEFAULTS, ...data });
    } catch (_) {
      // fall back to defaults
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <SettingsContext.Provider value={{ ...settings, reload: load }}>{children}</SettingsContext.Provider>
  );
};

export const useSiteSettings = () => useContext(SettingsContext);

/**
 * Normalise a phone number to digits-only for wa.me links.
 * Falls back to a safe default if empty/invalid.
 */
export const toWhatsAppNumber = (num) => {
  const digits = String(num || '').replace(/\D/g, '');
  return digits || '919810000000';
};

/**
 * Build a wa.me URL with encoded message.
 */
export const buildWhatsAppUrl = (num, message = '') => {
  const n = toWhatsAppNumber(num);
  const q = message ? `?text=${encodeURIComponent(message)}` : '';
  return `https://wa.me/${n}${q}`;
};
